import React from "react"
import { useTranslation } from "react-i18next"
import { useLoggedInEmployeeProfile } from "Shared/queries/employee.queries"
import { PurchaseOrder } from "../types/PurchaseOrder.interfaces"
import { PurchaseOrderActionButton } from "./PurchaseOrderActionButton"
import { getStateConfig } from "./PurchaseOrderActionButtons"

export const PurchaseOrderTodoApprovalButtons = ({ record }: { record: PurchaseOrder }) => {
    const user = useLoggedInEmployeeProfile()
    const { t } = useTranslation()

    const config = getStateConfig(record, user, false, t)

    return config?.buttons
        .slice(0, 2)
        .map((button, index) => (
            <PurchaseOrderActionButton
                className="btn-default min-w-120 mr-10"
                key={index}
                label={button.label}
                purchaseOrderId={record._id}
                purchaseOrderAction={button.purchaseOrderAction}
                isDisabled={button.isDisabled}
                type={button.type}
                color={button.color}
                icon={button.icon}
                rejectConfirmation={button.rejectConfirmation}
            />
        ))
}
